<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size lg_size" :class="viewResolution === 'view_mobile' ? 'mob_size' : viewResolution === 'view_tablet' ? 'tab_size' : ''">
            <a href="javascript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis">
                    <i>{{ $t('BUTTON.NOTICE.PREVIEW') }}</i>
                </dt>
                <dd class="in_preview">

                    <div class="grid_top mt-20">
                        <fieldset class="ui_fieldset">
                            <div>
                                <select class="slt_white w100p" v-model="selRes" @change="changeResolution">
                                    <option value="pc">PC</option>
                                    <option value="tablet">Tablet</option>
                                    <option value="mobile">Mobile</option>
                                </select>
                            </div>
                            <div>
                                <input type="text" class="text_input w100p" readonly :value="resMap[selRes].name">
                            </div>
                        </fieldset>
                    </div>

                    <div class="preview_wrap scroll">
                        <!-- view cont S -->
                        <div class="view_cont" :class="viewResolution"><!-- PC : view_pc / Tablet : view_tablet / Mobile : view_mobile -->
                            <!--
                            <div class="view_info">
                                <div class="view_category" v-if="typeof detail.PRD_CATEGORY_NM1 !== 'undefined'">
                                    {{ detail.PRD_CATEGORY_NM1 }} 
                                    <em v-if="typeof detail.PRD_CATEGORY_NM2 !== 'undefined'">&gt;</em> {{ detail.PRD_CATEGORY_NM2 }} 
                                    <em v-if="typeof detail.PRD_CATEGORY_NM3 !== 'undefined'">&gt;</em> {{ detail.PRD_CATEGORY_NM3 }}
                                </div>
                            </div>
                            -->
                            <dl class="view_subject">
                                <dt class="subject">
                                    <em v-if="detail.IMPORTANCE_YN === 'Y'" class="textcolor_important">[{{ $t('FIELD.GLOBAL.IMPORTANT') }}]</em>
                                    <em v-else-if="detail.MUST_READ_YN === 'Y'" class="textcolor_must">[{{ $t('FIELD.GLOBAL.MUSTREAD') }}]</em>
                                    {{ detail.KNOWLEDGE_TITLE | refTitle }}
                                </dt>
                                <!--
                                <dd class="desc">
                                    <span class="desc_Regist">
                                        <em>{{ $t('FIELD.GLOBAL.REGISTERED.BY') }}</em>
                                        {{ detail.REG_USER }} ({{ detail.REG_DT }})
                                    </span>
                                    <span class="desc_modify">
                                        <em>{{ $t('FIELD.GLOBAL.MODIFY.USER') }}</em>
                                        {{ detail.MODF_USER }} ({{ detail.MODF_DT }})
                                    </span>
                                </dd>
                                -->
                            </dl>

                            <div class="view_desc">
                                <!--
                                <table v-if="isSCMS" class="data_table_ty2 mb-20">
                                    <colgroup>
                                        <col width="20%">
                                        <col width="30%">
                                        <col width="20%">
                                        <col width="*">
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th class="text_left">{{ $t('FIELD.GLOBAL.SYMPTOM') }}</th>
                                            <td colspan="3">
                                                <ul class="in_dotlist" v-if="symptomList.length === 0">
                                                    <li>&nbsp;</li>
                                                </ul>
                                                <ul class="in_dotlist" v-else v-for="symptom in symptomList">
                                                    <li>{{ symptom.C_CODE_T_INFO }} > {{ symptom.CODE_T_INFO }}</li>
                                                </ul>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text_left">{{ $t('FIELD.KNOWLEDGE.MANUFACTURE') }}</th>
                                            <td>
                                                <ul class="in_dotlist">
                                                    <li>{{ (detail.MANUFACTURE_S_DT + '01') | dateFormat('MMM.YYYY') }} ~ {{ (detail.MANUFACTURE_E_DT + '01') | dateFormat('MMM.YYYY') }}</li>
                                                </ul>
                                            </td>
                                            <th class="text_left">{{ $t('FIELD.QNA.SERIAL.NUMBER') }}</th>
                                            <td>
                                                <ul class="in_dotlist" v-if="serialList.length === 0">
                                                    <li>&nbsp;</li>
                                                </ul>
                                                <ul class="in_dotlist" v-else v-for="serial in serialList">
                                                    <li>{{ serial.SERIAL_S }} ~ {{ serial.SERIAL_E}}</li>
                                                </ul>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text_left">{{ $t('FIELD.KNOWLEDGE.GUIDETYPE') }}</th>
                                            <td>{{ getGuideTypeName }}</td>
                                            <th class="text_left">{{ $t('FIELD.KNOWLEDGE.DEFECTTYPE') }}</th>
                                            <td>{{ getDefectTypeName }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                 -->

                                <div class="tab_wrap preview_tab_wrap">
                                    <ul class="tab_menu_02 tab_menus preview_tab_menus">
                                        <li class="on"><a href="javascript:">{{ $t('FIELD.GLOBAL.DESCRIPTION') }}</a></li>
                                    </ul>
                                    <div class="tab_contents">
                                        <div class="tab_cont preview_tab_cont" v-html="detail.KNOWLEDGE_DESC" />
                                    </div>
                                </div>
                            </div>
                            <!-- 200622수정 E -->
                        </div>
                        <!-- view cont E -->
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_wrap_full">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" @click="$emit('close')">{{ $t('BUTTON.GLOBAL.CLOSE') }}</a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue                                  from 'vue';
import { mapActions, mapGetters }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import qs                                   from 'query-string';
import axios                                from 'axios';
import moment                               from 'moment';
import api                                  from '@/service';
import store                                from '@/vuex/store';
import SDLLocale                            from '@/mixin/SDLLocale';
import { SDLUtil, StringUtil, MenuUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

const SCMS_CONTENTS_CD = MenuUtil.getScmsContents;

export default {
    name: 'KnowledgePreviewPopup',
    props : {
        KNOWLEDGE_ID:   { },
        BOARD_ID:       { },
        DETAIL:         { required: true }
    },
    data() {
        return {
            selRes: 'pc',
            resMap: {
                'pc': {
                    name: 'width: 1200px',
                    width: 1200,
                    height: 900
                },
                'tablet': {
                    name: 'width: 1024px',
                    width: 1024,
                    height: 600
                },
                'mobile': {
                    name: 'width: 360px',
                    width: 360,
                    height: 640
                }
            },
            viewResolution: 'view_pc', // view_pc, view_tablet, view_mobile

            isLoading : true,
            pageTitle: '',
            window: { width: 0, height: 0 },

            strSymptom: [],
            symptomList: [],
            serialList: [],
            detail: {},
            isReprocess: false,
            isRepair: false,
            isSCMS: false,

            isShare: false,
            isAllowSharing: false,
            distTarget: '',

            reloadModel: false,
            reloadParts: false,

            editorId: 'preview_editor_' + String(this.knowledgeId),
        }
    },
    computed: {
        ...mapGetters({
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            params: 'getParams',
        }),
        getKnowledgeId() {
            return this.KNOWLEDGE_ID;
        },
        getBoardId() {
            return this.BOARD_ID;
        },
        getEditorId() {
            return this.editorId;
        },
        getBoardCreationYN() {
            return store.getters.getParams.creationYn || 'N';
        },
        getDefectTypeName() {
            let defectType = this.detail.DEFECT_TYPE || '',
                defectTypeName = { "M":"Common", "C":"Call", "R":"Repair" };

            if(!SDLUtil.isNull(defectType)) {
                return defectTypeName[defectType];
            } else {
                return  '-';
            }
        },
        getGuideTypeName() {
            let guideType = this.detail.GUIDE_TYPE || '',
                guideTypeName = {"H":"H/W", "S":"S/W", "M":"Mechanical", "A":"Accessory", "I":"Info Sharing", "E":"Others"};

            if(!SDLUtil.isNull(guideType)) {
                return guideTypeName[guideType];
            } else {
                return  '-';
            }
        }
    },
    methods: {
        // initiation
        initLoad() {
            Vue.$log.info({ KNOWLEDGE_ID: this.getKnowledgeId, mList: '', boardId: this.getBoardId });
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/knowledge/knowledgeDetail.skp`,
                    qs.stringify({ KNOWLEDGE_ID: this.getKnowledgeId, boardId: this.getBoardId }),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                .then(res => {
                    return res.data;
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        changeResolution() {
            this.viewResolution = 'view_' + this.selRes;
        },
    },
    created() {
        /*
        this.initLoad().then(res => {
            this.strSymptom = res.strSymptom.rowData;
            this.symptomList = res.symptomList.rowData;
            this.serialList = res.serialList.rowData;
            this.detail = res.detail.rowData[0];

            // Knowledge Allow sharing 이 체크되어 있는 상태에서 법인 배포, Request Sharing 이 되지 않은 건만 버튼 활성
            this.isAllowSharing = StringUtil.strToBool(this.detail.ALLOW_SHARE);
            if(this.isRequestSharing && this.isAllowSharing) {
                let distTarget = this.detail.DIST_TARGET,
                    shareId = SDLUtil.nvl(this.detail.SHARE_ID, '');

                if(distTarget === 'S' && SDLUtil.isNull(shareId)) {
                    this.isShare = true;

                } else {
                    this.isShare = false;
                };

            } else {
                this.isShare = false;
            };

            // SCMS 컨텐츠 확인
            let menuGroupDetailCd = this.detail['MENU_GROUP_DETAIL_CD'] || '';
            if( _.includes(SCMS_CONTENTS_CD, menuGroupDetailCd) ) {
                if(menuGroupDetailCd === 'RT') this.isRepair = true;
                this.isSCMS = true;
            };
        });
        */
        Vue.$log.info(this.DETAIL);
        this.detail = this.DETAIL;

        SDLUtil.showLoadingBar(false);
        this.isLoading = false;
    },

};

</script>
<style scoped>
.lg_size { max-width: 1200px; }
.mob_size { width: 360px; }
.tab_size { width: 1024px; }
</style>


// WEBPACK FOOTER //
// src/skpComponents/common/popup/KnowledgePreviewPopup.vue